import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { CandidateEntity, CompanyEntity, JobOrderEntity } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const COPIES = strings.inventoryProfiles.accountability.drawer;

export const ENDPOINTS_BY_ENTITY = {
  [CandidateEntity.id]: Endpoints.CandidateClaimAccountability,
  [CompanyEntity.id]: Endpoints.CompanyClaimAccountability,
  [JobOrderEntity.id]: Endpoints.JobOrderClaimAccountability
};

export const FEATURE_FLAGS_MAP = {
  [CandidateEntity.id]: FeatureFlags.ClaimAccountabilityCandidate,
  [JobOrderEntity.id]: FeatureFlags.ClaimAccountabilityJobOrder,
  [CompanyEntity.id]: FeatureFlags.ClaimAccountabilityCompany
};
